import React from 'react';
import {HelpPanel} from '@amzn/awsui-components-react';

export type HelpSidePanelContent = {
    header: JSX.Element | null;
    body: JSX.Element | null;
    footer: JSX.Element | null;
};

const COMPONENT_TEXTS = {
    default_header: 'Help',
} as const;

export function HelpSidePanel({helpContent}: {helpContent: HelpSidePanelContent}): React.ReactElement {
    return (
        <HelpPanel header={helpContent.header ?? COMPONENT_TEXTS.default_header} footer={helpContent.footer}>
            {helpContent.body ?? <></>}
        </HelpPanel>
    );
}
